import { render } from "./OptimizedImage.vue?vue&type=template&id=3d385a12&scoped=true"
import script from "./OptimizedImage.vue?vue&type=script&lang=js"
export * from "./OptimizedImage.vue?vue&type=script&lang=js"

import "./OptimizedImage.vue?vue&type=style&index=0&id=3d385a12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d385a12"]])

export default __exports__